import Chip from '@mui/material/Chip';
import { capitalize } from 'lodash';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { CLUSTER_TYPES } from '../../../constants';

const EntityChip = ({ entity }) => {
  const { t } = useTranslation();

  const project = { label: t('project', { ns: 'project' }) };

  const instances = {
    [CLUSTER_TYPES.SOLR_CLUSTER]: {
      label: 'Solr',
    },
    [CLUSTER_TYPES.GPS_CLUSTER]: {
      label: t('generalServer', { ns: 'project' }),
    },
    [CLUSTER_TYPES.MODEL_CLUSTER]: {
      label: capitalize(t('model', { ns: 'model' })),
    },
    [CLUSTER_TYPES.CUSTOM_CLUSTER]: {
      label: t('customInst', { ns: 'customInst' }),
    },
    [CLUSTER_TYPES.ASSISTANT_CLUSTER]: {
      label: t('assistant', { ns: 'assistant' }),
    },
  };

  const entityType = entity?.clusterType
    ? instances[entity.clusterType]
    : project;

  return (
    <Chip
      size="small"
      sx={{ fontWeight: 600 }}
      variant="outlined"
      label={entityType.label}
    />
  );
};

EntityChip.propTypes = {
  entity: PropTypes.object.isRequired,
};

export default EntityChip;
